import { render, staticRenderFns } from "./AdminGroup.vue?vue&type=template&id=4f8de5d6&"
import script from "./AdminGroup.vue?vue&type=script&lang=js&"
export * from "./AdminGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports